import { PaymentFlowStep } from '@/v2/domains/Analytics/types/payment';
import {
  PendingFlowEvent,
  FlowName,
} from '@/v2/domains/Analytics/types/common';
import useCurrentUser from '@/v2/domains/Auth/hooks/useCurrentUser.hook';

export default function useCalculateFlowFromQueue() {
  const currentUser = useCurrentUser();

  const calculateFlow = (
    pendingEvents: PendingFlowEvent[]
  ): FlowName | null => {
    for (const [flowName, calculationFunction] of Object.entries(
      calculationFunctions
    )) {
      if (calculationFunction(pendingEvents, currentUser)) {
        return flowName as FlowName;
      }
    }
    return null;
  };

  return calculateFlow;
}

const calculationFunctions: Partial<
  Record<
    FlowName,
    (pendingEvents: PendingFlowEvent[], currentUser: any) => boolean
  >
> = {
  login_subscription_expired_paywall: (
    pendingEvents: PendingFlowEvent[],
    currentUser: any
  ): boolean => {
    const subscriptionExpiredEvent = pendingEvents.find(
      (e) => e.step === PaymentFlowStep.subscriptionExpiredDetected
    );
    const loginEvent = pendingEvents.find(
      (e) => e.step === PaymentFlowStep.loginCompleted
    );

    return (
      currentUser.userId &&
      !!loginEvent &&
      !!subscriptionExpiredEvent &&
      !subscriptionExpiredEvent.calculationData?.trial
    );
  },
  login_trial_expired_paywall: (
    pendingEvents: PendingFlowEvent[],
    currentUser: any
  ): boolean => {
    const subscriptionExpiredEvent = pendingEvents.find(
      (e) => e.step === PaymentFlowStep.subscriptionExpiredDetected
    );
    const loginEvent = pendingEvents.find(
      (e) => e.step === PaymentFlowStep.loginCompleted
    );

    return (
      currentUser.userId &&
      !!loginEvent &&
      !!subscriptionExpiredEvent &&
      !!subscriptionExpiredEvent.calculationData?.trial
    );
  },
  library_theme_private_content: (pendingEvents) =>
    !!pendingEvents.find(
      (e) => e.step === PaymentFlowStep.subscriptionOnlyContentViewed
    ),
};
